import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as DressData from "../Data/DressData";
import { Paintable } from "../GameObjects/Paintable";
import { PaintableLayer } from "../GameObjects/PaintableLayer";

export class PaintableDress extends Paintable {
    private _outline: PIXI.Sprite;

    constructor(pIndex: number, pCreateInput: boolean = true) {
        super(pIndex);

        const prefix: string = "dress" + this._index + "-";
        const pieceCount: number = DressData.DATA[this._index].layerCount;
        const paintableScale: number = DressData.DATA[this._index].paintableScale;
        const sheet: string = Constants.SPRITESHEET_DRESS_PREFIX + HLF.NumberUtils.addZeroPadding(this._index, 2);
        let layer: PaintableLayer;

        for (let i = 0; i < pieceCount; ++i) {
            const index: number = i;
            layer = new PaintableLayer(
                prefix + HLF.NumberUtils.addZeroPadding(i.toString(), 2),
                sheet,
                () => { this.onLayerPainted(index); },
                pCreateInput ? DressData.DATA[this._index].map : undefined,
                pCreateInput ? i : undefined,
            );
            layer.scale.set(paintableScale);
            this._layers.push(layer);
            this.addChild(this._layers[i]);
        }

        this._outline = HLF.PixiUtils.makeSprite(prefix + "outline", sheet);
        this.addChild(this._outline);
    }
}
